import { render, staticRenderFns } from "./WarningChangeTutor.vue?vue&type=template&id=35684e18&scoped=true"
import script from "./WarningChangeTutor.vue?vue&type=script&lang=js"
export * from "./WarningChangeTutor.vue?vue&type=script&lang=js"
import style0 from "./WarningChangeTutor.vue?vue&type=style&index=0&id=35684e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35684e18",
  null
  
)

export default component.exports